import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import classNames from 'classnames';

export const ClinicalEventsHeader = ({
  isEmptyEvents,
  title,
}: {
  isEmptyEvents: boolean;
  title?: string;
}) => {
  return (
    <h2
      className={classNames(
        'flex items-center leading-none mb-4 text-base font-semibold',
        { 'pl-4': !isEmptyEvents },
      )}
    >
      {isEmptyEvents ? (
        <div>
          <DescriptionOutlinedIcon />
        </div>
      ) : null}
      {title ?? 'Reported events'}
    </h2>
  );
};

export default ClinicalEventsHeader;
